/**
 * Card backgrounds: `public/carousel/1.svg` … `5.svg` (index 0..4 → file 1..5).
 * The SVGs are hand-built grunge posters (one motif per world); set
 * `CARD_BG_EXT` back to `'webp'` to return to the photo set.
 */
export const CARD_BG_EXT = 'svg';

export function getCardIndexFromEl(cardEl) {
  if (!cardEl) return 0;
  const raw = cardEl.dataset?.index;
  if (raw == null || raw === '') return 0;
  return Math.min(4, Math.max(0, parseInt(raw, 10) || 0));
}

export function getCardBackgroundUrl(index) {
  const n = Math.min(4, Math.max(0, index | 0)) + 1;
  return `/carousel/${n}.${CARD_BG_EXT}`;
}
